// The painted headlines of info, error and sign-in result pages (founder, 9 Oct 2026): two or three
// words on one line, painted like a picture, with the page's sentence under it in plain text.
// Most pages paint their own short title (e.g. "Payment confirmed"); these are the ones whose title
// is a long sentence. Hausa speaks to the learner as "ku" (founder, 9 Oct 2026).

export type StateHeadline = 'notFound' | 'offline' | 'error' | 'linkExpired' | 'linkInvalid' | 'linkUnavailable'

type Language = 'en' | 'ar' | 'ha'

const headlines: Record<Language, Record<StateHeadline, string>> = {
    en: { notFound: 'Not found', offline: 'Offline', error: 'Our mistake', linkExpired: 'Link expired', linkInvalid: 'Link not valid', linkUnavailable: 'Link unavailable' },
    ar: { notFound: 'غير موجودة', offline: 'لا اتصال', error: 'خطأ منّا', linkExpired: 'انتهى الرابط', linkInvalid: 'رابط غير صالح', linkUnavailable: 'الرابط غير متاح' },
    ha: { notFound: 'Ba a samu ba', offline: 'Babu intanet', error: 'Kuskurenmu ne', linkExpired: 'Mahadar ta ƙare', linkInvalid: 'Mahadar ba ta aiki', linkUnavailable: 'Mahadar ba ta samuwa' },
}

export const stateHeadlines = (language: string) => headlines[(language in headlines ? language : 'en') as Language]
